export enum ToastAlertType {
  MISSING_KYC = 'missing_kyc',
  MISSING_WALLET = 'missing_wallet',
  ERROR_LINK_PAYPAL_ACCOUNT = 'error_link_paypal_account',
}
